import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import PropTypes from 'prop-types';
import Box from 'components/atoms/Layout/Box/Box';

const StyledContentNavigation = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: ${props => props.theme.layout(2)};
  column-gap: ${props => props.theme.layout(4)};
  
  .ContentNavigation {
    &-title {
      ${props => props.theme.font2Css('body2')};
      font-size: ${props => props.theme.fontSize(13)};
      margin-right: ${props => props.theme.layout('0.5sp')};
    }
    
    &-button {
      min-width: unset;
    }
  }
  ${ComponentStyles}
`;

StyledContentNavigation.propTypes = {
  theme: PropTypes.object
};

export default StyledContentNavigation;
